/* DSL Snapchat Pixel events */
(function(){
  function ready(cb){ var iv = setInterval(function(){ if (window.snaptr) { clearInterval(iv); cb(); } }, 200); setTimeout(function(){ clearInterval(iv); }, 10000); }
  ready(function(){
    var c = window.DSL_CONSENT && window.DSL_CONSENT.get();
    if (c && c.marketing === false) return;
    if (location.pathname.indexOf("/products/") === 0) {
      var m = location.pathname.match(/\/products\/([^\/?#]+)/);
      if (m) fetch("/products/" + m[1] + ".js").then(function(r){return r.json();}).then(function(p){
        snaptr("track", "VIEW_CONTENT", {item_ids: [String(p.id)], price: p.price/100, currency: "EUR"});
      });
    }
    document.addEventListener("dsl:cart:add", function(e){
      var d = e.detail || {};
      snaptr("track", "ADD_CART", {item_ids: [String(d.variant_id||d.product_id)], price: (d.price||0)/100, currency: "EUR"});
    });
  });
})();